import React from 'react'

class FileInput extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      fileName : null
    }
  }

  onChange = (e) => {
    const { input: { onChange } } = this.props,
          targetFile = e.target.files[0];

    onChange(targetFile);

    const fileName = targetFile.name;

    this.setState({
      fileName : fileName
    });
    $('.file-name').text(fileName);
  }

  //파일 삭제
  onClick = () => {
    $("#ex_file").val("");
  }

  render() {
    const { input: { value } } = this.props

    return (
      <div className='filebox'>
        <label htmlFor='ex_file'>
          엑셀파일 업로드
          <input type="file" id='ex_file' value={value} onChange={this.onChange} onClick={this.onClick}/>
        </label>
        <span className='file-name'></span>
      </div>
    )
  }
}

export default FileInput
